import { render, staticRenderFns } from "./WelcomePage.vue?vue&type=template&id=22def35e&"
import script from "./WelcomePage.vue?vue&type=script&lang=ts&"
export * from "./WelcomePage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports